import {useNavigationLoaderStore} from "@/shared/model/navigationLoaderStore";
import styles from "./NavigationLoader.module.scss";

export const NavigationLoader = () => {
    const loading = useNavigationLoaderStore(s => s.loading);

    if (!loading) {
        return null;
    }

    return (
        <div className={styles.loader}>
            <div className={styles.spinner}></div>
        </div>
    );
};
